import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ab7cf06"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "base-checkbox" }
const _hoisted_2 = ["id", "checked", "value", "disabled"]
const _hoisted_3 = ["for"]
const _hoisted_4 = ["placeholder"]

import { getUUID } from '@/common/Utils'
import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseCheckbox',
  props: {
  value: { type: Boolean || String },
  checked: { type: Boolean },
  isTextInput: { type: Boolean },
  disabled: { type: Boolean },
  defaultValue: { type: String },
},
  emits: ["check"],
  setup(__props, { emit: emits }: { emit: ({
  (event: 'check', value: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props





const id = ref(getUUID())

const inputEl = ref()
const inputTextEl = ref()
const labelEl = ref()

const handleClick = (event: MouseEvent) => {
  event?.preventDefault()
  toggle()
}

const toggle = (): void => {
  inputEl.value.checked = !inputEl.value.checked
  if (inputEl.value.checked) {
    emits('check', true)
    setInputTextFocus()
  } else {
    emits('check', false)
  }
}

const setInputTextFocus = (): void => {
  if (props.isTextInput) {
    inputTextEl.value.focus()
  }
}

const changeTextInput = (): void => {
  if (!props.isTextInput) return

  if (inputTextEl.value.value) {
    inputEl.value.value = inputTextEl.value.value
    labelEl.value.innerText = inputTextEl.value.value
  } else {
    inputEl.value.value = props.defaultValue
    labelEl.value.innerText = props.defaultValue
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["field", { disabled: __props.disabled }])
    }, [
      _createElementVNode("input", {
        ref_key: "inputEl",
        ref: inputEl,
        id: id.value,
        class: _normalizeClass(["checkbox", { 'checkbox-text': __props.isTextInput }]),
        type: "checkbox",
        checked: __props.checked,
        value: __props.value,
        disabled: __props.disabled,
        onInput: _cache[0] || (_cache[0] = ($event: any) => (setInputTextFocus()))
      }, null, 42, _hoisted_2),
      _createElementVNode("div", {
        ref_key: "inputTextEl",
        ref: inputTextEl,
        class: "checkmark",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (handleClick($event)))
      }, null, 512),
      _createElementVNode("label", {
        ref_key: "labelEl",
        ref: labelEl,
        class: "label",
        for: id.value,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (handleClick($event)))
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 8, _hoisted_3),
      (__props.isTextInput)
        ? (_openBlock(), _createElementBlock("input", {
            key: 0,
            class: "input-text",
            placeholder: __props.defaultValue,
            onInput: _cache[3] || (_cache[3] = ($event: any) => (changeTextInput()))
          }, null, 40, _hoisted_4))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})